import { render, staticRenderFns } from "./PriceListBrowse.vue?vue&type=template&id=5dadd90a&scoped=true"
import script from "./PriceListBrowse.vue?vue&type=script&lang=ts"
export * from "./PriceListBrowse.vue?vue&type=script&lang=ts"
import style0 from "./PriceListBrowse.vue?vue&type=style&index=0&id=5dadd90a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5dadd90a",
  null
  
)

export default component.exports